import React from "react";
import { bookingReportColumns } from "./BookingReportTableData";
import DataTable from "../../../../../../Common/DataTable/DataTable";
import DataTableHeader from "../../../../../../Common/DataTableHeader/DataTableHeader";
import DataTableFooter from "../../../../../../Common/DataTableFooter/DataTableFooter";

const BookingReportTable = ({ tableData }) => {
  const formatted = tableData.map((item) => ({
    name: item.guest_name,
    roomType: item.room_type,
    checkIn: item.check_in,
    checkOut: item.check_out,
    paidAmount: item.paid_amount,
    dueAmount: item.due_amount,
    bookingStatus: (
      <span
        className={`badge bg-${
          {
            checked_in: "success",
            checked_out: "primary",
            reserved: "warning",
          }[item.status] || "secondary"
        }`}
      >
        {{
          checked_in: "Check In",
          checked_out: "Check Out",
          reserved: "Reserved",
        }[item.status] || item.status}
      </span>
    ),
    paymentStatus: (
      <span
        className={`badge bg-${
          item.payment_status === "complete" ? "success" : "warning"
        }`}
      >
        {item.payment_status}
      </span>
    ),
  }));

  return (
    <>
      <DataTableHeader />
      <DataTable columns={bookingReportColumns} data={formatted} />
      <DataTableFooter dataT={formatted} />
    </>
  );
};

export default BookingReportTable;
